import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: "Mathematical Equations Solver",
      description: "Developed a comprehensive Python program for solving various mathematical equations using numerical methods",
      technologies: ["Python", "NumPy", "SciPy"],
      icon: "fa-calculator",
      color: "from-blue-500 to-blue-600"
    },
    {
      title: "CNN Image Classification",
      description: "Implemented convolutional neural networks for advanced image classification tasks with high accuracy",
      technologies: ["CNN", "Deep Learning", "TensorFlow"],
      icon: "fa-image",
      color: "from-purple-500 to-purple-600"
    },
    {
      title: "Polynomial Interpolation & Integration",
      description: "Created algorithms for polynomial interpolation and numerical integration using Python",
      technologies: ["Python", "Algorithms", "Numerical Methods"],
      icon: "fa-wave-square",
      color: "from-green-500 to-green-600"
    },
    {
      title: "PageRank Algorithm Implementation",
      description: "Implemented Google's PageRank algorithm using Gaussian Pivot method for web page ranking",
      technologies: ["Python", "Algorithms", "Graph Theory"],
      icon: "fa-search",
      color: "from-red-500 to-red-600"
    },
    {
      title: "RDBMS Comparative Study",
      description: "Conducted comprehensive analysis and performance comparison of various relational database systems",
      technologies: ["SQL", "Database Analysis", "Performance"],
      icon: "fa-database",
      color: "from-yellow-500 to-yellow-600"
    },
    {
      title: "PCA Analysis on Decathlon Dataset",
      description: "Performed Principal Component Analysis on sports data using R for dimensional reduction and visualization",
      technologies: ["R", "PCA", "Data Visualization"],
      icon: "fa-chart-line",
      color: "from-indigo-500 to-indigo-600"
    },
    {
      title: "Statistical Analysis with R",
      description: "Comprehensive descriptive statistical analysis and data visualization using R programming",
      technologies: ["R", "Statistics", "Data Analysis"],
      icon: "fa-chart-bar",
      color: "from-pink-500 to-pink-600"
    },
    {
      title: "Hotel Management Backend",
      description: "Full-featured backend application for hotel management with authentication and real-time data processing",
      technologies: ["ASP.NET Core", "C#", "SQL Server"],
      icon: "fa-hotel",
      color: "from-teal-500 to-teal-600"
    }
  ];

  return (
    <section id="projects" className="section-padding bg-white/70 backdrop-blur-md shadow-lg">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Projects</h2>
          <div className="w-20 h-1 bg-primary-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A collection of projects showcasing my expertise in data science, 
            machine learning, and software development
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className={`h-2 bg-gradient-to-r ${project.color} rounded-t-xl`}></div>
              
              <div className="p-6">
                <div className={`w-16 h-16 bg-gradient-to-r ${project.color} rounded-lg flex items-center justify-center mb-4 mx-auto`}>
                  <i className={`fas ${project.icon} text-2xl text-white`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                  {project.title}
                </h3>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-4 text-center">
                  {project.description}
                </p>
                
                <div className="flex flex-wrap gap-2 justify-center">
                  {project.technologies.map((tech, techIndex) => (
                    <span 
                      key={techIndex}
                      className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
